<template>
  <CustomSelect
    v-model="selectedGoal"
    :value="value"
    inputId="userGoalPicker"
    :inputLabel="inputLabel"
    @input="$emit('input', $event)"
    :customOptions="userGoalsOptions"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedGoal: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String],
      default: "هدف کاربر",
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedGoal) {
      this.selectedGoal = this.defaultSelectedGoal;
    }
  },
  data() {
    return {
      selectedGoal: null,
      userGoalsOptions: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "امتحانات بین المللی",
          value: "امتحانات بین المللی",
        },
        {
          text: "امتحانات داخلی",
          value: "امتحانات داخلی",
        },
        {
          text: "مکالمه تخصصی",
          value: "مکالمه تخصصی",
        },
        {
          text: "مکالمه روزمره",
          value: "مکالمه روزمره",
        },
        {
          text: "زبان کودک",
          value: "زبان کودک",
        },
        {
          text: "مهاجرت",
          value: "مهاجرت",
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
